import gql from 'graphql-tag';

export const UPDATE_FACEBOOK_ADS_STATE_MUTATION = gql`
  mutation UpdateFacebookAdsStatusMutation($ids: [ID!]!, $facebookState: FacebookAdStateEnum!) {
    updateFacebookAdsState(ids: $ids, facebookState: $facebookState) {
      facebookAds {
        id
        facebookState
      }
      errors
    }
  }
`;
